webpackJsonp([1],{

/***/ "/HE7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"v03","duration":400}},[(_vm.navIsOpen)?_c('the-navigation',{on:{"hide":_vm.onHideNav}}):_vm._e()],1),_vm._v(" "),_c('router-link',{staticClass:"caption caption_work-with-us",class:{ 'caption_work-with-us-white' : _vm.isMainPage || _vm.navIsOpen },attrs:{"to":"/career"}},[_vm._v("Work with us")]),_vm._v(" "),_c('button',{staticClass:"button button_nav-switch",class:_vm.navSwitchClasses,on:{"click":_vm.onClickNavSwitch}},[_c('span',{staticClass:"button__line"}),_vm._v(" "),_c('span',{staticClass:"button__line"}),_vm._v(" "),_c('span',{staticClass:"button__line"})]),_vm._v(" "),_c('router-link',{staticClass:"logo logo_default",class:_vm.logoClasses,attrs:{"to":"/","exact":""}},[_c('div',{staticClass:"logo__image"}),_vm._v(" "),_c('div',{staticClass:"logo__caption"},[_vm._v("Trade"),_c('br'),_vm._v("marketing")])]),_vm._v(" "),_c('router-view',{on:{"switchNavSwitch":_vm.onSwitchNavSwitch,"switchLogo":_vm.onSwitchLogo,"hideFooter":_vm.onHideFooter,"showFooter":_vm.onShowFooter}}),_vm._v(" "),_c('the-footer',{ref:"footer",class:{ 'footer_main-page' : _vm.isMainPage }}),_vm._v(" "),_c('the-notification')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/a7v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('button',{staticClass:"button button_modal-close-button",on:{"click":_vm.onClickCloseButton}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2rbg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_vm._m(0),_vm._v(" "),(!_vm.loaded)?_c('div',{staticClass:"loader"}):_c('div',{staticClass:"container"},[_vm._l((_vm.news),function(item){return _c('div',{staticClass:"layoyt layout_default-page"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(item.date))])]),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('div',{staticClass:"news-item news-item_short"},[_c('div',{staticClass:"news-item__title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"news-item__wrapper"},[_c('div',{staticClass:"news-item__short-desc"},[_vm._v(_vm._s(item.short_desc))]),_vm._v(" "),_c('div',{staticClass:"news-item__read-more"},[_c('router-link',{staticClass:"link link_gray",attrs:{"to":("/news/" + (item.id))}},[_vm._v("Read more")])],1)])])])])}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.next !== null),expression:"next !== null"}],staticClass:"link link_news-view-more",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClickViewMoreLink.apply(null, arguments)}}},[_c('span',{staticClass:"link__text"},[_vm._v("View more")])])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title title_h1"},[_vm._v("News")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3ISe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main main_main-page"},[_c('transition',{attrs:{"name":"image","mode":"in-out","duration":600}},[(_vm.loaded)?_c('div',{key:_vm.currentSlide.id,staticClass:"image image_slide-background",class:{ 'image_blurred' : _vm.detailedView },style:({ 'background-image': ("url(" + (_vm.currentSlide.image) + ")") })}):_vm._e()]),_vm._v(" "),_c('svg',{staticClass:"figure figure_main-background",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"none","viewBox":"0 0 100 100"}},[_c('path',{ref:"figurePath",attrs:{"fill":"#FFF","d":"M0 0 H37.5 L18.75 100 H0 Z"}})]),_vm._v(" "),_c('section',{ref:"section",staticClass:"section section_slide"},[_c('section',{staticClass:"section__item section__item_left"},[_c('div',{ref:"special",staticClass:"special"},[_c('div',{staticClass:"special__container"},[_c('a',{staticClass:"special__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClickSpecialLink.apply(null, arguments)}}},[_vm._v("About us")]),_vm._v(" "),_c('div',{staticClass:"special__title",on:{"click":_vm.onClickSpecialTitle,"mouseenter":_vm.onMouseEnterSpecialTitle,"mouseleave":_vm.onMouseLeaveSpecialTitle}},[_vm._v("Professionals")]),_vm._v(" "),_c('div',{staticClass:"special__caption"},[_vm._v("Creatività e razionalità. Il giusto mix tra l’innovazione dei creativi e la nostra esperienza di field marketing. Siamo nati così, nel 1996. Già in fase di ideazione eliminiamo le proposte non realizzabili, garantendo la certezza dell’attuazione, facendo risparmiare tempo e denaro.")])])]),_vm._v(" "),_c('div',{ref:"captionSlideMove",staticClass:"caption caption_slide-move"},[_vm._v("Scroll")])]),_vm._v(" "),_c('section',{staticClass:"section__item section__item_right"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.detailedView),expression:"detailedView"}],staticClass:"link link_white link_back-to-short-view",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClickBack.apply(null, arguments)}}},[_vm._v("Back")]),_vm._v(" "),(_vm.loaded)?_c('div',{ref:"slide",staticClass:"slide"},[_c('div',{staticClass:"slide__container"},[_c('transition',{attrs:{"name":"title","duration":600}},[_c('div',{key:_vm.currentSlide.id,staticClass:"slide__title",class:{ 'slide__title_default' : _vm.slideIndex === 0 },on:{"click":_vm.onClickSlideTitle,"mouseenter":_vm.onMouseEnterSlideTitle,"mouseleave":_vm.onMouseLeaveSlideTitle}},[_vm._v(_vm._s(_vm.currentSlide.title))])]),_vm._v(" "),_c('div',{staticClass:"slide__content"},[_c('div',{staticClass:"indicator indicator_slide"},[_c('span',{staticClass:"indicator__marker"},[_vm._v(_vm._s(_vm._f("leadingZero")(_vm.slideIndex)))]),_vm._v("/"+_vm._s(_vm._f("leadingZero")(_vm.slidesCount - 1))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"service service_slide"},[_c('transition',{attrs:{"name":"service","duration":800}},[_c('div',{key:_vm.currentSlide.id,staticClass:"service__container"},[_c('div',{staticClass:"service__name"},[_vm._v(_vm._s(_vm.currentSlide.name))]),_vm._v(" "),_c('div',{staticClass:"service__short-desc",domProps:{"innerHTML":_vm._s(_vm.currentSlide.short_desc)}}),_vm._v(" "),_c('transition',{attrs:{"name":"v01","duration":400}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.detailedView && _vm.videoPath),expression:"detailedView && videoPath"}],staticClass:"service__video-wrapper"},[_c('video',{staticClass:"service__video",attrs:{"controls":_vm.videoControls,"src":_vm.videoPath}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.videoPreview),expression:"videoPreview"}],staticClass:"service__video-play",on:{"click":_vm.onClickVideo}})])]),_vm._v(" "),_c('transition',{attrs:{"name":"v01","duration":400}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.detailedView),expression:"detailedView"}],staticClass:"service__full-desc",domProps:{"innerHTML":_vm._s(_vm.currentSlide.desc)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSlide.desc && !_vm.detailedView),expression:"currentSlide.desc && !detailedView"}],staticClass:"service__more"},[_c('a',{staticClass:"link link_white",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClickLearnMore.apply(null, arguments)}}},[_vm._v("Learn more")])])],1)])],1)])],1)]):_vm._e(),_vm._v(" "),(_vm.loaded && _vm.nextSlide !== null)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.detailedView),expression:"detailedView"}],staticClass:"caption caption_title-next-slide",on:{"click":_vm.onClickCaptionTitleNextSlide}},[_vm._v(_vm._s(_vm.nextSlide.url_title))]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5DS7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Utils__ = __webpack_require__("ppOi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModalWindow',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Utils__["a" /* default */]],

  created: function created() {
    this.toggleClasses(true, 'modal-open');
  },
  mounted: function mounted() {
    this.$emit('open');
  },
  beforeDestroy: function beforeDestroy() {
    this.toggleClasses(false, 'modal-open');
  },


  methods: {
    onClickCloseButton: function onClickCloseButton() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "5Dq/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormControlFile_vue__ = __webpack_require__("tWjo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b7b9712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormControlFile_vue__ = __webpack_require__("vZWG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormControlFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b7b9712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormControlFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5MEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("syIe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67ddc9bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("W7jP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67ddc9bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6UgG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotFoundPage'
});

/***/ }),

/***/ "7wLe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("e2ZZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f81d33ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("WZss");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f81d33ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Hp9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("6UgG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dda0e04a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("jSVI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dda0e04a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8dJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"notification","enter-active-class":"notification_enter-active","enter-to-class":"notification_enter-to","leave-active-class":"notification_leave-active","leave-to-class":"notification_leave-to","duration":400}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"notification notification_cookie-policy"},[_c('button',{staticClass:"button button_notification-close-button",on:{"click":_vm.onClickCloseButton}}),_vm._v(" "),_c('div',{staticClass:"notification__content"},[_vm._v("Utilizziamo cookie propri e di terzi per finalità analitiche. È possibile configurare o rifiutare i cookie facendo clic su “Configurazione dei cookie”. Inoltre, gli utenti possono accettare tutti i cookie premendo il pulsante “Accetta tutti i cookie”. Per ulteriori informazioni, è possibile consultare la nostra\n      "),_c('router-link',{staticClass:"link link_white",attrs:{"to":"/privacy"}},[_vm._v("\n        Politica sull’utilizzo dei Cookie\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"notification__buttons"},[_c('button',{staticClass:"button button-notification-accept",on:{"click":_vm.onClickAcceptButton}},[_vm._v("\n        ACCETTA TUTTI I COOKIE\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"link link__policy",attrs:{"to":"/privacy#100"},nativeOn:{"click":function($event){return _vm.onClickCloseButton.apply(null, arguments)}}},[_vm._v("\n        CONFIGURAZIONE DEI COOKIE\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8eIB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TabsList',

  data: function data() {
    return {
      activeIndex: 0,
      tabs: []
    };
  },


  watch: {
    activeIndex: function activeIndex(value) {
      this.$emit('change', value);
    }
  },

  mounted: function mounted() {
    console.log(this.$children);
    this.tabs = this.$children;
  },


  methods: {
    onClickNavItem: function onClickNavItem(index) {
      this.activeIndex = index;
    }
  }
});

/***/ }),

/***/ "8vzm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer_padding-fix"},[_c('div',{staticClass:"footer__container"},[_c('div',{staticClass:"footer__helper"}),_vm._v(" "),_c('div',{staticClass:"footer__contacts"},[_c('div',{staticClass:"footer__footer-text-links"},[_c('router-link',{staticClass:"footer__privacy",attrs:{"to":"/privacy"}},[_vm._v("Privacy policy")]),_vm._v(" "),_c('router-link',{staticClass:"footer__privacy",attrs:{"to":"/certificazioni"}},[_vm._v("Certificazioni")])],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('a',{staticClass:"footer__made-in",attrs:{"href":"//rutorika.com","target":"_blank"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer__address"},[_vm._v("\n        © 2021 4MKTG For Marketing srl "),_c('br',{staticClass:"footer__break"}),_vm._v("\n        P.I 03840620961 — REA MB-1705666 "),_c('br',{staticClass:"footer__break"}),_vm._v("\n        Via Torri Bianche, 10 — 20871 "),_c('br',{staticClass:"footer__break"}),_vm._v("\n        Vimercate (MB)\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "95n6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('the-nav-titles'),_vm._v(" "),_vm._m(0),_vm._v(" "),(!_vm.loaded)?_c('div',{staticClass:"loader"}):[_c('div',{staticClass:"container"},[_c('div',{staticClass:"layout layout_default-page"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('tabs-list',{on:{"change":_vm.onChangeTabsListUffici},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((_vm.UfficiCities),function(city,index){return _c('tabs-item',{directives:[{name:"show",rawName:"v-show",value:(index === props.activeIndex),expression:"index === props.activeIndex"}],key:city.id,attrs:{"name":city.name}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(city.note !== null),expression:"city.note !== null"}],staticClass:"tabs-item__note"},[_vm._v(_vm._s(city.note))]),_vm._v(" "),_c('div',{staticClass:"tabs-item__contacts"},_vm._l((city.contacts),function(value,key){return _c('dl',{directives:[{name:"show",rawName:"v-show",value:(value !== null),expression:"value !== null"}],staticClass:"list list_tabs-item-contacts"},[_c('dt',{staticClass:"list__term"},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('dd',{staticClass:"list__definition"},[_vm._v(_vm._s(value))])])}),0)])})}}])})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentCity && _vm.currentCity.map !== null),expression:"currentCity && currentCity.map !== null"}],ref:"mapUficci",staticClass:"map"}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"layout layout_default-page"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('tabs-list',{on:{"change":_vm.onChangeTabsList},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((_vm.cities),function(city,index){return _c('tabs-item',{directives:[{name:"show",rawName:"v-show",value:(index === props.activeIndex),expression:"index === props.activeIndex"}],key:city.id,attrs:{"name":city.name}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(city.note !== null),expression:"city.note !== null"}],staticClass:"tabs-item__note"},[_vm._v(_vm._s(city.note))]),_vm._v(" "),_c('div',{staticClass:"tabs-item__contacts"},_vm._l((city.contacts),function(value,key){return _c('dl',{directives:[{name:"show",rawName:"v-show",value:(value !== null),expression:"value !== null"}],staticClass:"list list_tabs-item-contacts"},[_c('dt',{staticClass:"list__term"},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('dd',{staticClass:"list__definition"},[_vm._v(_vm._s(value))])])}),0)])})}}])})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentCity && _vm.currentCity.map !== null),expression:"currentCity && currentCity.map !== null"}],ref:"map",staticClass:"map"})],_vm._v(" "),(_vm.modalWindowVisible && _vm.isMobile)?_c('modal-window',{on:{"open":_vm.onOpenModalWindow,"close":_vm.onCloseModalWindow}},[_c('div',{ref:"modalViewMap",staticClass:"map map_modal-view"})]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title title_h1"},[_vm._v("Contacts")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v("Uffici")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v("Magazzini")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BtGf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TabsItem',

  props: {
    name: String
  }
});

/***/ }),

/***/ "EVhE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("iUn4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33f62a0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("TIIg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33f62a0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ene4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewsItemPage',

  props: {
    id: Number
  },

  data: function data() {
    return {
      date: null,
      title: null,
      shortDesc: null,
      desc: null,
      image: null,
      prev: null,
      next: null
    };
  },
  created: function created() {
    this.fetchData();
  },


  watch: {
    $route: function $route() {
      this.fetchData();
    }
  },

  methods: {
    fetchData: function fetchData() {
      this.$http.get('/api/news/' + this.id).then(this.onFulfilled);
    },
    onFulfilled: function onFulfilled(res) {
      var data = res.data;

      this.date = data.date;
      this.title = data.title;
      this.shortDesc = data.short_desc;
      this.desc = data.desc;
      this.image = data.image;
      this.prev = data.prev;
      this.next = data.next;
    },
    prevNews: function prevNews() {
      if (this.prev !== null) {
        this.$router.push({
          name: 'NewsItem',
          params: {
            id: this.prev
          }
        });
      }
    },
    nextNews: function nextNews() {
      if (this.next !== null) {
        this.$router.push({
          name: 'NewsItem',
          params: {
            id: this.next
          }
        });
      }
    },
    onClickPrevNewsLink: function onClickPrevNewsLink() {
      this.prevNews();
    },
    onClickNextNewsLink: function onClickNextNewsLink() {
      this.nextNews();
    }
  }
});

/***/ }),

/***/ "F85r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('div',{staticClass:"tabs__nav"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{staticClass:"tabs__nav-item",class:{ 'tabs__nav-item_active' : index === _vm.activeIndex },on:{"click":function($event){return _vm.onClickNavItem(index)}}},[_vm._v(_vm._s(tab.name))])}),0),_vm._v(" "),_c('div',{staticClass:"tabs__items"},[_vm._t("default",null,{"activeIndex":_vm.activeIndex})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FI/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"id":_vm.name,"name":_vm.name},on:{"focus":_vm.onFocusFormControlEl,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.value=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.value}},[_vm._v(_vm._s(option.text))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GyQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__ = __webpack_require__("UVMV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0e9c39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__ = __webpack_require__("8vzm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0e9c39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ih92":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "InOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormControlCheckbox',

  props: {
    name: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      value: null
    };
  },


  computed: {
    filled: function filled() {
      return this.value === null ? false : this.value;
    }
  },

  watch: {
    filled: function filled(value) {
      this.$emit('filled', value);
    }
  }
});

/***/ }),

/***/ "IyYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.value),expression:"value",modifiers:{"lazy":true}}],attrs:{"id":_vm.name,"type":_vm.type,"name":_vm.name},domProps:{"value":(_vm.value)},on:{"focus":_vm.onFocusFormControlEl,"blur":_vm.onBlurFormControlEl,"change":function($event){_vm.value=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K1ME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_Cookie__ = __webpack_require__("z0Wd");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TheNotification',

  data: function data() {
    return {
      isOpen: false
    };
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_0__js_Cookie__["a" /* default */].get('privacy') === undefined) {
      this.showNotification();
    }
    if (__WEBPACK_IMPORTED_MODULE_0__js_Cookie__["a" /* default */].get('gta_disabled') === undefined) {
      window['ga-disable-UA-91170168-12'] = true;
      __WEBPACK_IMPORTED_MODULE_0__js_Cookie__["a" /* default */].set('gta_disabled', '1', {
        expires: 31536000
      });
    }
  },


  methods: {
    hideNotification: function hideNotification() {
      this.isOpen = false;
    },
    showNotification: function showNotification() {
      this.isOpen = true;
    },
    onClickCloseButton: function onClickCloseButton() {
      this.hideNotification();
      __WEBPACK_IMPORTED_MODULE_0__js_Cookie__["a" /* default */].set('privacy', '0', {
        expires: 0
      });
    },
    onClickAcceptButton: function onClickAcceptButton() {
      if (__WEBPACK_IMPORTED_MODULE_0__js_Cookie__["a" /* default */].get('privacy') === undefined || __WEBPACK_IMPORTED_MODULE_0__js_Cookie__["a" /* default */].get('privacy') === '0') {
        this.hideNotification();
        window['ga-disable-UA-91170168-12'] = false;
        __WEBPACK_IMPORTED_MODULE_0__js_Cookie__["a" /* default */].set('gta_disabled', '0', {
          expires: 31536000
        });
        __WEBPACK_IMPORTED_MODULE_0__js_Cookie__["a" /* default */].set('privacy', '1', {
          expires: 31536000
        });
      }
    }
  }
});

/***/ }),

/***/ "KTZ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormControlText_vue__ = __webpack_require__("Zjxo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224f17f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormControlText_vue__ = __webpack_require__("IyYQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormControlText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224f17f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormControlText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488f5046_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("/HE7");
function injectStyle (ssrContext) {
  __webpack_require__("Ih92")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488f5046_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NA+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Utils__ = __webpack_require__("ppOi");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GalleryImages',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Utils__["a" /* default */]],

  props: {
    images: {
      type: Array,
      default: []
    }
  },

  data: function data() {
    return {
      activeIndex: 0
    };
  },


  computed: {
    countImages: function countImages() {
      var result = null;

      if (this.isMobile) {
        result = this.images.length;
      } else {
        result = this.images.length - 2;
      }

      return result;
    }
  },

  watch: {
    isMobile: function isMobile(bool) {
      if (bool) {
        this.removeClones();
        this.$refs.container.removeEventListener('transitionend', this.onTransitionEnd);
      } else {
        this.addClones();
        this.$refs.container.addEventListener('transitionend', this.onTransitionEnd);
      }
    }
  },

  created: function created() {
    if (!this.isMobile) {
      this.addClones();
    }
  },
  mounted: function mounted() {
    if (!this.isMobile) {
      this.$refs.container.addEventListener('transitionend', this.onTransitionEnd);
    }
  },


  methods: {
    addClones: function addClones() {
      var _images;

      var cloned = this.images.slice(0, 2);
      (_images = this.images).push.apply(_images, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(cloned));
    },
    removeClones: function removeClones() {
      this.images.splice(-2, 2);
    },
    onTransitionEnd: function onTransitionEnd() {
      var _this = this;

      if (this.activeIndex === this.countImages) {
        this.$refs.container.style.transitionDuration = '0ms';
        this.activeIndex = 0;

        // @todo
        // Так себе решение. Нужно разобраться почему анимация происходит,
        // если duration равно 0.
        setTimeout(function () {
          _this.$refs.container.style.transitionDuration = '400ms';
        }, 50);
      }
    },
    onClickPaginationItem: function onClickPaginationItem(index) {
      this.activeIndex = index;
    },
    onClickControl: function onClickControl() {
      this.nextImage();
    },
    nextImage: function nextImage() {
      var currentIndex = this.activeIndex;
      var countImages = this.countImages;
      var nextIndex = currentIndex + 1;

      this.activeIndex = nextIndex > countImages - 1 ? this.isMobile ? 0 : countImages : nextIndex;
    },
    prevImage: function prevImage() {
      var currentIndex = this.activeIndex;
      var countImages = this.countImages;
      var nextIndex = currentIndex - 1;

      this.activeIndex = nextIndex < 0 ? countImages - 1 : nextIndex;
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NO6y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormControlCheckbox_vue__ = __webpack_require__("InOf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_766f5c3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormControlCheckbox_vue__ = __webpack_require__("WsPv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormControlCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_766f5c3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormControlCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NgGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNavigation_vue__ = __webpack_require__("Ym74");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ddc0474_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNavigation_vue__ = __webpack_require__("lUiH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ddc0474_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PMDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("yb/9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76bdc4d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("2rbg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76bdc4d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QDBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormControl_vue__ = __webpack_require__("fHMA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dad3ac2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormControl_vue__ = __webpack_require__("hEtS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormControl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dad3ac2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormControl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RDU/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("jcmg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e0a18bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("3ISe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e0a18bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RLRX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsList_vue__ = __webpack_require__("8eIB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4ab038a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabsList_vue__ = __webpack_require__("F85r");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4ab038a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TIIg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('the-nav-titles'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title title_h1"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(!_vm.loaded)?_c('div',{staticClass:"loader"}):[_c('div',{staticClass:"container"},[_c('div',{staticClass:"layout layout_default-page"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(_vm.section01.title))])]),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('p',{staticClass:"lead lead_top",domProps:{"innerHTML":_vm._s(_vm.section01.desc)}})])])]),_vm._v(" "),_c('img',{staticClass:"image image_about-us",attrs:{"src":_vm.images[0].src,"alt":_vm.images[0].title}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"layout layout_default-page section2"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(_vm.section02.title))])]),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('p',{staticClass:"lead lead_default",domProps:{"innerHTML":_vm._s(_vm.section02.desc)}}),_vm._v(" "),_c('div',{staticClass:"facts"},_vm._l((_vm.facts),function(value,key){return _c('div',{staticClass:"facts-item"},[_c('div',{staticClass:"facts-item__indicator"},[_vm._v(_vm._s(value))]),_vm._v(" "),_c('div',{staticClass:"facts-item__caption"},[_vm._v(_vm._s(key))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"layout layout_default-page section3"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(_vm.section03.title))])]),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('p',{staticClass:"lead lead_default",domProps:{"innerHTML":_vm._s(_vm.section03.desc)}}),_vm._v(" "),_c('div',{staticClass:"clients"},_vm._l((_vm.certificate),function(item){return _c('div',{staticClass:"client"},[_c('img',{class:['client__logo', item.modificateSelector || ''],attrs:{"src":item.src}})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"layout layout_default-page section4"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(_vm.section04.title))])]),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('p',{staticClass:"lead lead_default",domProps:{"innerHTML":_vm._s(_vm.section04.desc)}}),_vm._v(" "),_c('div',{staticClass:"clients"},_vm._l((_vm.logotypes),function(src){return _c('div',{class:['client', 'client__new-order']},[_c('img',{class:['client__logo', 'client__width-limit', 'client__height-limit'],attrs:{"src":src}})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"layout layout_default-page"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(_vm.section05.title))])]),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('p',{staticClass:"lead lead_default",domProps:{"innerHTML":_vm._s(_vm.section05.desc)}})])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"layout layout_default-page"},[_c('div',{staticClass:"layout__item"}),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"lead lead_default"},[_vm._v("Lavora con noi.")]),_vm._v(" "),_c('router-link',{staticClass:"button button_default",attrs:{"to":"/career"}},[_vm._v("View openings")])],1)])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UThT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Utils__ = __webpack_require__("ppOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ModalWindow__ = __webpack_require__("o46f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TabsItem__ = __webpack_require__("pPVn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TabsList__ = __webpack_require__("RLRX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TheNavTitles__ = __webpack_require__("tqpC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactsPage',

  components: {
    ModalWindow: __WEBPACK_IMPORTED_MODULE_1__components_ModalWindow__["a" /* default */],
    TabsItem: __WEBPACK_IMPORTED_MODULE_2__components_TabsItem__["a" /* default */],
    TabsList: __WEBPACK_IMPORTED_MODULE_3__components_TabsList__["a" /* default */],
    TheNavTitles: __WEBPACK_IMPORTED_MODULE_4__components_TheNavTitles__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Utils__["a" /* default */]],

  data: function data() {
    return {
      cities: [],
      UfficiCities: [],
      currentCity: null,
      loaded: false,
      modalWindowVisible: false
    };
  },
  created: function created() {
    this.fetchData();
  },


  methods: {
    fetchData: function fetchData() {
      this.$http.get('/static/api/contacts.json').then(this.onFulfilled);
    },
    onFulfilled: function onFulfilled(res) {
      var _this = this;

      var data = res.data;

      this.cities = data.filter(function (item) {
        if (item.type == 'magazzini') {
          return item;
        }
      });

      this.UfficiCities = data.filter(function (item) {
        if (item.type == 'uffici') {
          return item;
        }
      });
      this.currentCity = this.cities[3];
      this.currentCityUffici = this.UfficiCities[0];

      this.loaded = true;

      this.$nextTick(function () {
        _this.loadGoogleMaps();
      });
    },
    loadGoogleMaps: function loadGoogleMaps() {
      if (window.google === undefined) {
        // @todo
        // change API_KEY for production
        var src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAR6D6PliL9KJaX2v829LE_xrR0cVkwUV0';
        this.loadScript(src);
      } else {
        this.initGoogleMaps();
        this.initGoogleMapsUffici();
      }
    },
    loadScript: function loadScript(src) {
      var script = document.createElement('script');

      script.type = 'text/javascript';
      script.async = true;

      script.onload = this.initGoogleMaps;

      document.getElementsByTagName('head')[0].appendChild(script);

      script.src = src;
    },
    initGoogleMaps: function initGoogleMaps(mapNode) {
      this.initGoogleMapsUffici();
      // @todo
      // Needed refactor?
      if (mapNode instanceof Event) {
        mapNode = this.$refs.map;
      } else {
        mapNode = mapNode || this.$refs.map;
      }

      var styles = [{
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        stylers: [{
          hue: '#00aaff'
        }, {
          saturation: -100
        }, {
          gamma: 2.15
        }, {
          lightness: 12
        }]
      }, {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{
          visibility: 'on'
        }, {
          lightness: 24
        }]
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{
          lightness: 57
        }]
      }];

      var options = {
        center: this.currentCity.map.center,
        zoom: 17,
        disableDefaultUI: true,
        styles: styles
        // gestureHandling: 'greedy',
      };

      var gMapInstance = new google.maps.Map(mapNode, options);

      var icon = {
        anchor: new google.maps.Point(0, 52),
        scaledSize: new google.maps.Size(41, 52),
        size: new google.maps.Size(41, 52),
        url: '/static/pin@2x.png'
      };

      var marker = new google.maps.Marker({
        icon: icon,
        map: gMapInstance,
        position: options.center
      });

      if (this.isMobile && !this.modalWindowVisible) {
        google.maps.event.addDomListener(marker, 'click', this.onClickGoogleMapsMarker);
      }
    },
    initGoogleMapsUffici: function initGoogleMapsUffici(mapNode) {
      // @todo
      // Needed refactor?
      if (mapNode instanceof Event) {
        mapNode = this.$refs.mapUficci;
      } else {
        mapNode = mapNode || this.$refs.mapUficci;
      }

      var styles = [{
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        stylers: [{
          hue: '#00aaff'
        }, {
          saturation: -100
        }, {
          gamma: 2.15
        }, {
          lightness: 12
        }]
      }, {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{
          visibility: 'on'
        }, {
          lightness: 24
        }]
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{
          lightness: 57
        }]
      }];

      var options = {
        center: this.currentCityUffici.map.center,
        zoom: 17,
        disableDefaultUI: true,
        styles: styles
        // gestureHandling: 'greedy',
      };

      var gMapInstance = new google.maps.Map(mapNode, options);

      var icon = {
        anchor: new google.maps.Point(0, 52),
        scaledSize: new google.maps.Size(41, 52),
        size: new google.maps.Size(41, 52),
        url: '/static/pin@2x.png'
      };

      var marker = new google.maps.Marker({
        icon: icon,
        map: gMapInstance,
        position: options.center
      });

      if (this.isMobile && !this.modalWindowVisible) {
        google.maps.event.addDomListener(marker, 'click', this.onClickGoogleMapsMarker);
      }
    },
    onClickGoogleMapsMarker: function onClickGoogleMapsMarker() {
      this.showModalWindow();
    },
    onChangeTabsList: function onChangeTabsList(index) {
      this.currentCity = this.cities[index];
      this.initGoogleMaps();
    },
    onChangeTabsListUffici: function onChangeTabsListUffici(index) {
      this.currentCityUffici = this.UfficiCities[index];
      this.initGoogleMapsUffici();
    },
    showModalWindow: function showModalWindow() {
      this.modalWindowVisible = true;
    },
    hideModalWindow: function hideModalWindow() {
      this.modalWindowVisible = false;
    },
    onOpenModalWindow: function onOpenModalWindow() {
      var mapNode = this.$refs.modalViewMap;
      this.initGoogleMaps(mapNode);
      this.initGoogleMapsUffici(mapNode);
    },
    onCloseModalWindow: function onCloseModalWindow() {
      this.hideModalWindow();
    }
  }
});

/***/ }),

/***/ "UVMV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TheFooter'
});

/***/ }),

/***/ "VgS+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("jjAL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52fe7c4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Z1qn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52fe7c4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W7jP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('the-nav-titles'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title title_h1"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(!_vm.loaded)?_c('div',{staticClass:"loader"}):_c('div',{staticClass:"container"},[_vm._l((_vm.sections),function(section,index){return _c('div',{key:index,staticClass:"layout layout_default-page"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(section.title))])]),_vm._v(" "),_c('div',{staticClass:"layout__item privacy",domProps:{"innerHTML":_vm._s(section.text)}})])}),_vm._v(" "),_c('div',{staticClass:"layout layout_default-page"},[_c('div',{staticClass:"layout__item"}),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('h3',{staticClass:"privacy__title"},[_vm._v("Cookie tecnici")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"privacy__container--with-switch"},[_c('h3',{staticClass:"privacy__title"},[_vm._v("Cookie analitici")]),_vm._v(" "),_c('div',{staticClass:"privacy__line"}),_vm._v(" "),_c('label',{staticClass:"switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gtaEnabled),expression:"gtaEnabled"}],staticClass:"switch__input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.gtaEnabled)?_vm._i(_vm.gtaEnabled,null)>-1:(_vm.gtaEnabled)},on:{"click":_vm.toggleGta,"change":function($event){var $$a=_vm.gtaEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.gtaEnabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.gtaEnabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.gtaEnabled=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"slider round"})])]),_vm._v(" "),_vm._m(1)])])],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy__container"},[_c('p',{staticClass:"privacy__text"},[_vm._v("Questi cookie non possono essere disattivati perché necessari al buon funzionamento dei nostri servizi. Garantiscono la normale navigazione e fruizione del sito web.")]),_vm._v(" "),_c('img',{staticClass:"privacy__icon",attrs:{"src":"/static/info.svg","alt":"info"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy__container"},[_c('p',{staticClass:"privacy__text"},[_vm._v("Utilizziamo questi cookie per questi cookie per raccogliere informazioni, in forma aggregata, sul numero degli utenti e su come questi visitano il sito stesso tramite Google Analitics, al fine di migliorare le performance del sito.")]),_vm._v(" "),_c('img',{staticClass:"privacy__icon",attrs:{"src":"/static/info.svg","alt":"info"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WZss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('the-nav-titles'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title title_h1"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(!_vm.loaded)?_c('div',{staticClass:"loader"}):_c('div',{staticClass:"container"},_vm._l((_vm.sections),function(section,index){return _c('div',{key:index,staticClass:"layout layout_default-page"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(section.title))])]),_vm._v(" "),_c('div',{staticClass:"layout__item privacy",domProps:{"innerHTML":_vm._s(section.text)}})])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WsPv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],ref:"input",attrs:{"type":"checkbox","id":_vm.name,"name":_vm.name},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YVAl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormContainer_vue__ = __webpack_require__("xhN/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dd9293a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormContainer_vue__ = __webpack_require__("sJx0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dd9293a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_about_us_Index_vue__ = __webpack_require__("EVhE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_career_Index_vue__ = __webpack_require__("VgS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_contacts_Index_vue__ = __webpack_require__("mQH1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_main_Index_vue__ = __webpack_require__("RDU/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_news_Index_vue__ = __webpack_require__("PMDi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_news_Item_vue__ = __webpack_require__("pxey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_not_found_Index_vue__ = __webpack_require__("8Hp9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_privacy_policy_Index_vue__ = __webpack_require__("5MEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_certificazioni_Index_vue__ = __webpack_require__("7wLe");


/* eslint-disable */














__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var routes = [{
  component: __WEBPACK_IMPORTED_MODULE_4__pages_about_us_Index_vue__["a" /* default */],
  name: 'AboutUs',
  path: '/about',
  meta: {
    title: '4MKTG | Trade marketing projects — about us',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — about us'
    }, {
      name: 'description',
      content: 'Creatività e razionalità. Il giusto mix tra l’innovazione dei creativi e la nostra esperienza di field marketing. Siamo nati così, nel 1996. '
    }, {
      property: 'og:description',
      content: 'Creatività e razionalità. Il giusto mix tra l’innovazione dei creativi e la nostra esperienza di field marketing. Siamo nati così, nel 1996. '
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_5__pages_career_Index_vue__["a" /* default */],
  name: 'Career',
  path: '/career',
  meta: {
    title: '4MKTG | Trade marketing projects — career',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — career'
    }, {
      name: 'description',
      content: 'Siamo sempre alla ricerca di nuovi talenti per incrementare il nostro team: passione, impegno e volontà di portare buoni risultati sono requisiti indispensabili.'
    }, {
      property: 'og:description',
      content: 'Siamo sempre alla ricerca di nuovi talenti per incrementare il nostro team: passione, impegno e volontà di portare buoni risultati sono requisiti indispensabili.'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_6__pages_contacts_Index_vue__["a" /* default */],
  name: 'Contacts',
  path: '/contacts',
  meta: {
    title: '4MKTG | Trade marketing projects — contacts',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — contacts'
    }, {
      name: 'description',
      content: 'Headquarter: tel. +390396854596 | Email: info@4mktg.it |Ind.: Via Torri Bianche 10 edificio Betulla | CAP: 20871 Vimercate'
    }, {
      property: 'og:description',
      content: 'Headquarter: tel. +390396854596 | Email: info@4mktg.it |Ind.: Via Torri Bianche 10 edificio Betulla | CAP: 20871 Vimercate'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_9__pages_news_Item_vue__["a" /* default */],
  name: 'NewsItem',
  path: '/news/:id(\\d+)',
  props: function props(route) {
    return { id: +route.params.id };
  },
  meta: {
    title: '4MKTG | Trade marketing projects — news',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — news'
    }, {
      name: 'description',
      content: 'Stay up to date with the most recent 4MKTG related news stories.'
    }, {
      property: 'og:description',
      content: 'Stay up to date with the most recent 4MKTG related news stories.'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_8__pages_news_Index_vue__["a" /* default */],
  name: 'News',
  path: '/news',
  meta: {
    title: '4MKTG | Trade marketing projects — news',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — news'
    }, {
      name: 'description',
      content: 'Stay up to date with the most recent 4MKTG related news stories.'
    }, {
      property: 'og:description',
      content: 'Stay up to date with the most recent 4MKTG related news stories.'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_11__pages_privacy_policy_Index_vue__["a" /* default */],
  name: 'PrivacyPolicy',
  path: '/privacy',
  meta: {
    title: '4MKTG | Trade marketing projects — privacy',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — privacy'
    }, {
      name: 'description',
      content: '4MKTG | Trade marketing projects — privacy'
    }, {
      property: 'og:description',
      content: '4MKTG | Trade marketing projects — privacy'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_12__pages_certificazioni_Index_vue__["a" /* default */],
  name: 'Certificazioni',
  path: '/certificazioni',
  meta: {
    title: '4MKTG | Trade marketing projects — certificazioni',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — certificazioni'
    }, {
      name: 'description',
      content: '4MKTG | Trade marketing projects — certificazioni'
    }, {
      property: 'og:description',
      content: '4MKTG | Trade marketing projects — certificazioni'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_7__pages_main_Index_vue__["a" /* default */],
  name: 'Main',
  path: '/',
  meta: {
    title: '4MKTG | Trade marketing projects',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects'
    }, {
      name: 'description',
      content: 'Dal 1996 siamo un partner affidabile per la realizzazione di progetti che uniscono efficienza e creatività. Proveniamo da esperienze in multinazionali pertanto conosciamo bene le aspettative delle aziende e riusciamo ad essere autonomi nella gestione dei progetti.'
    }, {
      property: 'og:description',
      content: 'Dal 1996 siamo un partner affidabile per la realizzazione di progetti che uniscono efficienza e creatività. Proveniamo da esperienze in multinazionali pertanto conosciamo bene le aspettative delle aziende e riusciamo ad essere autonomi nella gestione dei progetti.'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_7__pages_main_Index_vue__["a" /* default */],
  name: 'Main',
  path: '/:slideURL(gdo)',
  props: true,
  meta: {
    title: '4MKTG | Trade marketing projects — presidio GDO',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — presidio GDO'
    }, {
      name: 'description',
      content: 'La miglior visibilità a scaffale e in extra display. Mettiamo il&nbsp;tuo prodotto nelle mani del consumatore.'
    }, {
      property: 'og:description',
      content: 'La miglior visibilità a scaffale e in extra display. Mettiamo il&nbsp;tuo prodotto nelle mani del consumatore.'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_7__pages_main_Index_vue__["a" /* default */],
  name: 'Main',
  path: '/:slideURL(merchandising)',
  props: true,
  meta: {
    title: '4MKTG | Trade marketing projects — sampling & merchandising',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — sampling & merchandising'
    }, {
      name: 'description',
      content: 'Gestiamo tutte le fasi del progetto: creatività, produzione, logistica, selezione del personale; pertanto, tutto quello che&nbsp;proponiamo è creativo, ma realizzabile senza intoppi in fase di operatività.'
    }, {
      property: 'og:description',
      content: 'Gestiamo tutte le fasi del progetto: creatività, produzione, logistica, selezione del personale; pertanto, tutto quello che&nbsp;proponiamo è creativo, ma realizzabile senza intoppi in fase di operatività.'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_7__pages_main_Index_vue__["a" /* default */],
  name: 'Main',
  path: '/:slideURL(horeca)',
  props: true,
  meta: {
    title: '4MKTG | Trade marketing projects — horeca',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — horeca'
    }, {
      name: 'description',
      content: 'Presentiamo nuovi prodotti per un corretto posizionamento, aumentiamo la distribuzione e/o le referenze trattate, rendiamo visibili i prodotti per generare richiesta spontanea.'
    }, {
      property: 'og:description',
      content: 'Presentiamo nuovi prodotti per un corretto posizionamento, aumentiamo la distribuzione e/o le referenze trattate, rendiamo visibili i prodotti per generare richiesta spontanea.'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_7__pages_main_Index_vue__["a" /* default */],
  name: 'Main',
  path: '/:slideURL(mystery-client)',
  props: true,
  meta: {
    title: '4MKTG | Trade marketing projects — mystery client',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — mystery client'
    }, {
      name: 'description',
      content: 'Verifichiamo capillarmente l’applicazione delle guide lines delle aziende nostre clienti da parte dei loro partner locali: esposizione e presentazione di prodotti o servizi, effettuazione delle promozioni, proattività del personale.'
    }, {
      property: 'og:description',
      content: 'Verifichiamo capillarmente l’applicazione delle guide lines delle aziende nostre clienti da parte dei loro partner locali: esposizione e presentazione di prodotti o servizi, effettuazione delle promozioni, proattività del personale.'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_7__pages_main_Index_vue__["a" /* default */],
  name: 'Main',
  path: '/:slideURL(events)',
  props: true,
  meta: {
    title: '4MKTG | Trade marketing projects — events',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — events'
    }, {
      name: 'description',
      content: 'Creatività, location, target: i migliori eventi per far desiderare il tuo prodotto ai consumatori.'
    }, {
      property: 'og:description',
      content: 'Creatività, location, target: i migliori eventi per far desiderare il tuo prodotto ai consumatori.'
    }]
  }
},
// {
//   component: Main,
//   name: 'Main',
//   path: '/:slideURL(popupvillage)',
//   props: true,
//   meta: {
//     title: '4MKTG | Trade marketing projects — event village experience',
//     metaTags: [
//       {
//         name: 'og:title',
//         content: '4MKTG | Trade marketing projects — event village experience',
//       },
//       {
//         name: 'description',
//         content: 'Il Pop Up Village è un vero e proprio villaggio creato da camper all’interno di grandi eventi sportivi, musicali e di intrattenimento.',
//       },
//       {
//         property: 'og:description',
//         content: 'Il Pop Up Village è un vero e proprio villaggio creato da camper all’interno di grandi eventi sportivi, musicali e di intrattenimento.',
//       },
//     ],
//   },
// },
{
  component: __WEBPACK_IMPORTED_MODULE_7__pages_main_Index_vue__["a" /* default */],
  name: 'Main',
  path: '/:slideURL(creative)',
  props: true,
  meta: {
    title: '4MKTG | Trade marketing projects — creative',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — creative'
    }, {
      name: 'description',
      content: 'Idee creative per presentare il tuo prodotto al trade e ai consumatori.'
    }, {
      property: 'og:description',
      content: 'Idee creative per presentare il tuo prodotto al trade e ai consumatori.'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_7__pages_main_Index_vue__["a" /* default */],
  name: 'Main',
  path: '/:slideURL(logistics)',
  props: true,
  meta: {
    title: '4MKTG | Trade marketing projects — logistics',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — logistics'
    }, {
      name: 'description',
      content: 'Le location adatte, il target corretto. I migliori eventi per far desiderare il tuo prodotto ai consumatori.'
    }, {
      property: 'og:description',
      content: 'Le location adatte, il target corretto. I migliori eventi per far desiderare il tuo prodotto ai consumatori.'
    }]
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_7__pages_main_Index_vue__["a" /* default */],
  name: 'Main',
  path: '/:slideURL(mr-root)',
  props: true,
  meta: {
    title: '4MKTG | Trade marketing projects — plant-based food solutions',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — plant-based food solutions'
    }, {
      name: 'description',
      content: 'Mr. Root è una divisione di 4MKTG dedicata alla distribuzione di prodotti plant based premium.'
    }, {
      property: 'og:description',
      content: 'Mr. Root è una divisione di 4MKTG dedicata alla distribuzione di prodotti plant based premium.'
    }]
  }
}, {
  alias: '*',
  component: __WEBPACK_IMPORTED_MODULE_10__pages_not_found_Index_vue__["a" /* default */],
  name: 'NotFound',
  path: '/404',
  meta: {
    title: '4MKTG | Trade marketing projects — Not Found',
    metaTags: [{
      name: 'og:title',
      content: '4MKTG | Trade marketing projects — Not Found'
    }, {
      name: 'description',
      content: '4MKTG | Trade marketing projects — Not Found'
    }, {
      property: 'og:description',
      content: '4MKTG | Trade marketing projects — Not Found'
    }]
  }
}];

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: scrollBehavior,
  linkActiveClass: 'link_active',
  linkExactActiveClass: 'link_exact',
  routes: routes
});
var stopScrollFlag = false;

router.beforeEach(function (to, from, next) {
  if (stopScrollFlag) {
    return;
  }

  var nearestWithTitle = to.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.title;
  });

  if (to.hash === '#100') {
    setTimeout(function () {
      window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' });
    }, 200);
  }

  var nearestWithMeta = to.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.metaTags;
  });

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  var element = document.querySelectorAll('[data-vue-router-controlled]');
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(element).map(function (el) {
    return el.parentNode.removeChild(el);
  });

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(function (tagDef) {
    var tag = document.createElement('meta');

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tagDef).forEach(function (key) {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(function (tag) {
    return document.head.appendChild(tag);
  });

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/**
 * @param {Object} to
 * @param {Object} from
 * @param {Object} savedPosition
 * @return {Object}
 */
function scrollBehavior(to, from, savedPosition) {
  if (to && to.hash) {
    return {
      selector: to.hash,
      behavior: 'smooth'
    };
  } else if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 };
  }
}

window.addEventListener('wheel', function (event) {
  stopScrollFlag = event.target.closest('body.nav-open') ? true : false;
  setTimeout(function () {
    return stopScrollFlag = false;
  }, 200);
});
window.addEventListener('click', function (event) {
  stopScrollFlag = false;
});

/***/ }),

/***/ "Ym74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TheNavigation',

  data: function data() {
    return {
      items: [{
        link: null,
        name: 'Our services',
        subitems: [{
          link: '/gdo',
          name: 'Presidio GDO'
        }, {
          link: '/merchandising',
          name: 'Sampling & Merchandising'
        }, {
          link: '/horeca',
          name: 'HoReCa'
        }, {
          link: '/mystery-client',
          name: 'Mystery Client'
        }, {
          link: '/events',
          name: 'Events'
        },
        // {
        //   link: '/popupvillage',
        //   name: 'Event Village Experience',
        // },
        {
          link: '/creative',
          name: 'Creative'
        }, {
          link: '/logistics',
          name: 'Logistics'
        }, {
          link: '/mr-root',
          name: 'Plant-Based Food Solutions'
        }]
      }, {
        link: '/about',
        name: 'About us',
        subitems: null
      }, {
        link: '/career',
        name: 'Career',
        subitems: null
      }, {
        link: '/news',
        name: 'News',
        subitems: null
      }, {
        link: '/contacts',
        name: 'Contacts',
        subitems: null
      }],
      news: [],
      loading: false
    };
  },
  created: function created() {
    this.switchClasses(true);
    this.getNews();
  },
  beforeDestroy: function beforeDestroy() {
    this.switchClasses(false);
  },


  methods: {
    onClickItemName: function onClickItemName(e) {
      var node = e.currentTarget;
      var submenuNode = node.closest('.nav-item_subitems');
      var isSubmenu = submenuNode !== null;
      var isCurrentRoute = node.closest('.link_exact') !== null;

      if (isSubmenu) {
        this.toggleVisibilitySubmenu(submenuNode);
      } else if (isCurrentRoute) {
        this.hide();
      }
    },
    onClickSubitemName: function onClickSubitemName(e) {
      var node = e.currentTarget;
      var submenuNode = node.closest('.nav-item_subitems');
      var isSubmenu = submenuNode !== null;
      var isCurrentRoute = node.closest('.link_exact') !== null;

      if (isSubmenu) {
        this.toggleVisibilitySubmenu(submenuNode);
      }

      if (isCurrentRoute) {
        this.hide();
      }
    },
    toggleVisibilitySubmenu: function toggleVisibilitySubmenu(submenu) {
      var cssClass = 'nav-item_open';
      var condition = submenu.classList.contains(cssClass);

      if (condition) {
        submenu.classList.remove(cssClass);
      } else {
        submenu.classList.add(cssClass);
      }
    },
    hide: function hide() {
      this.$emit('hide');
    },
    switchClasses: function switchClasses(isOpen) {
      var nodes = [document.documentElement, document.body];

      var cssClass = 'nav-open';

      nodes.forEach(function (node) {
        if (isOpen) {
          node.classList.add(cssClass);
        } else {
          node.classList.remove(cssClass);
        }
      });
    },
    getNews: function getNews() {
      var _this = this;

      this.$http.get('/api/news').then(function (response) {
        _this.loading = true;
        _this.news = response.data.news;
      }, function (error) {
        console.log(error.statusText);
      });
    },
    getItems: function getItems(item) {
      if (item.name == 'News') {
        if (!!this.news) {
          if (this.news.length == 0) {
            return false;
          }
        } else {
          if (!this.news) {
            return false;
          }
        }
      }

      return true;
    }
  }
});

/***/ }),

/***/ "Z1qn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('the-nav-titles'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title title_h1"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(!_vm.loaded)?_c('div',{staticClass:"loader"}):[_c('div',{staticClass:"container"},[_c('div',{staticClass:"layout layout_default-page"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(_vm.lead.title))])]),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('p',{staticClass:"lead lead_top",domProps:{"innerHTML":_vm._s(_vm.lead.desc)}})])])]),_vm._v(" "),_c('div',{staticClass:"container container_collapse-right"},[_c('gallery-images',{ref:"gallery",staticClass:"gallery_career-page",attrs:{"images":_vm.images}})],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"layout layout_default-page"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(_vm.positions.title))])]),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('p',{staticClass:"lead lead_default",domProps:{"innerHTML":_vm._s(_vm.positions.desc)}}),_vm._v(" "),_vm._l((_vm.positions.items),function(position){return _c('div',{staticClass:"position"},[_c('div',{staticClass:"position__name"},[_vm._v(_vm._s(position.name))]),_vm._v(" "),_c('div',{staticClass:"position__desc",domProps:{"innerHTML":_vm._s(position.desc)}})])})],2)]),_vm._v(" "),_c('div',{staticClass:"layout layout_default-page"},[_c('div',{staticClass:"layout__item"},[_c('h2',{staticClass:"title title_h2"},[_vm._v(_vm._s(_vm.apply.title))])]),_vm._v(" "),_c('div',{staticClass:"layout__item"},[_c('p',{staticClass:"lead lead_default",domProps:{"innerHTML":_vm._s(_vm.apply.desc)}}),_vm._v(" "),_c('form-container',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('form-control',{attrs:{"name":"first_name","label":"Nome","required":true}}),_vm._v(" "),_c('form-control',{attrs:{"name":"last_name","label":"Cognome","required":true}}),_vm._v(" "),_c('form-control',{attrs:{"name":"phone","type":"tel","label":"Telefono","required":true}}),_vm._v(" "),_c('form-control',{attrs:{"name":"email","type":"email","label":"Email","required":true}}),_vm._v(" "),_c('form-control',{attrs:{"name":"region","type":"select","label":"Regione","options":_vm.optionsRegion,"required":true}}),_vm._v(" "),_c('form-control',{attrs:{"name":"city","label":"Città","required":true}}),_vm._v(" "),_c('form-control',{attrs:{"name":"vakancy","type":"select","label":"Posizione desiderata","options":_vm.optionsVakancy,"required":true}}),_vm._v(" "),_c('form-control',{attrs:{"name":"file","type":"file","required":true},scopedSlots:_vm._u([{key:"before",fn:function(props){return [_c('label',{staticClass:"form-control__button",attrs:{"for":"file"}},[_c('span',{staticClass:"form-control__button-text"},[_vm._v("ALLEGA CV")])]),_vm._v(" "),_vm._l((props.value),function(item){return (props.value !== null)?_c('p',{staticClass:"form-control__file-name"},[_vm._v(_vm._s(item.name))]):_vm._e()})]}}],null,true)}),_vm._v(" "),_c('form-control',{attrs:{"name":"checkbox","type":"checkbox","required":true}},[_c('template',{slot:"after"},[_c('div',{staticClass:"form-control__wrapper"},[_c('label',{staticClass:"form-control__check-mark",attrs:{"for":"checkbox"}}),_vm._v(" "),_c('div',{staticClass:"form-control__caption"},[_vm._v("Dichiaro di aver preso visione dell'"),_c('a',{staticClass:"career_privacy",attrs:{"href":"/privacy"}},[_vm._v("informativa privacy")]),_vm._v(" ed autorizzo 4MKTG For Marketing SRL al trattamento dei miei dati personali ai sensi del Regolamento UE 2016/679 per la gestione della candidatura.")])])])],2),_vm._v(" "),_c('div',{staticClass:"form__footer"},[_c('div',{staticClass:"form__submit"},[_c('button',{staticClass:"button button_form-career-page",attrs:{"type":"submit"}},[_vm._v("INVIA LA CANDIDATURA")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(props.verified === false),expression:"props.verified === false"}],staticClass:"form__hint"},[_vm._v("Per favore, inserisci le informazioni obbligatorie")])])]}}])})],1)])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zibr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormControlSelect_vue__ = __webpack_require__("yQyu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f03dde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormControlSelect_vue__ = __webpack_require__("FI/i");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormControlSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f03dde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormControlSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZioS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Utils__ = __webpack_require__("ppOi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TheNavTitles',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Utils__["a" /* default */]],

  data: function data() {
    return {
      titles: []
    };
  },


  watch: {
    isMobile: function isMobile(bool) {
      if (bool) {
        this.destroy();
      } else {
        this.init();
      }
    }
  },

  mounted: function mounted() {
    if (!this.isMobile) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },


  methods: {
    init: function init() {
      this.update();

      window.addEventListener('scroll', this.update);
    },
    destroy: function destroy() {
      window.removeEventListener('scroll', this.update);

      this.titles.forEach(function (item) {
        item.classList.remove('title_hide');
      });

      this.titles.length = 0;
    },
    update: function update() {
      var _this = this;

      var titles = document.querySelectorAll('.title_h2');
      var targetPosition = document.querySelector('.nav-title').getBoundingClientRect();

      titles.forEach(function (item, index) {
        var position = item.getBoundingClientRect();

        if (position.bottom <= targetPosition.bottom + 40) {
          var _index = _this.titles.indexOf(item);

          if (_index === -1) {
            _this.titles.push(item);
            item.classList.add('title_hide');
          }
        } else {
          var _index2 = _this.titles.indexOf(item);

          if (_index2 !== -1) {
            _this.titles.splice(_index2, 1);
            item.classList.remove('title_hide');
          }
        }
      });
    },
    goToItem: function goToItem(item) {
      var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.layout_default-page').eq(item);
      var top = el.offset().top - 300;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({ scrollTop: top });
    }
  }
});

/***/ }),

/***/ "Zjxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormControlText',

  props: {
    name: {
      type: String,
      required: true
    },

    type: {
      type: String,
      default: 'text'
    }
  },

  data: function data() {
    return {
      focused: false,
      value: null
    };
  },


  computed: {
    filled: function filled() {
      return this.value !== null && this.value !== '' && this.value !== undefined;
    }
  },

  watch: {
    value: function value(_value) {
      this.$emit('value', _value);
    },
    filled: function filled(value) {
      this.$emit('filled', value);
    },
    focused: function focused(value) {
      this.$emit('focused', value);
    }
  },

  methods: {
    onFocusFormControlEl: function onFocusFormControlEl() {
      this.focused = true;
    },
    onBlurFormControlEl: function onBlurFormControlEl() {
      this.focused = false;
    }
  }
});

/***/ }),

/***/ "bNO+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-title"},_vm._l((_vm.titles),function(title,i){return _c('a',{staticClass:"nav-title__item",on:{"click":function($event){return _vm.goToItem(i)}}},[_vm._v(_vm._s(title.textContent))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c67H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-item"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dHT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery"},[_c('div',{ref:"container",staticClass:"gallery__container",style:({
      'transform' : ("translateX(" + (-100 * _vm.activeIndex) + "%)"),
      'transition-duration' : '400ms'
    })},_vm._l((_vm.images),function(image){return _c('div',{staticClass:"gallery__image-wrapper"},[_c('div',{staticClass:"gallery__image",style:({ 'background-image' : ("url(" + image + ")") })})])}),0),_vm._v(" "),_c('div',{staticClass:"gallery__pagination"},_vm._l((_vm.countImages),function(number,index){return _c('div',{staticClass:"gallery__pagination-item",class:{ 'gallery__pagination-item_active' : index === _vm.activeIndex},on:{"click":function($event){return _vm.onClickPaginationItem(index)}}})}),0),_vm._v(" "),_c('div',{staticClass:"gallery__control",on:{"click":_vm.onClickControl}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dKUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Touch handler
 */
var TouchHandler = function () {
  /** @param {HTMLElement} el */
  function TouchHandler(el) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TouchHandler);

    this._el = el;
    this._handlers = [];
    this._wrappedHandlers = [];
  }

  /**
   * @param {String} event
   * @param {Function} fn
   * @return {Function}
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TouchHandler, [{
    key: '_wrapper',
    value: function _wrapper(event, fn) {
      var prevClientX = null;
      var prevClientY = null;

      return function (e) {
        var touchEvent = e.changedTouches[0];

        if (e.type === 'touchstart') {
          var target = e.target;
          var link = target.closest('a');

          if (!link) {
            e.preventDefault();
          }

          prevClientX = touchEvent.clientX;
          prevClientY = touchEvent.clientY;
        } else {
          var currClientX = touchEvent.clientX;
          var currClientY = touchEvent.clientY;
          var deltaX = currClientX - prevClientX;
          var deltaY = currClientY - prevClientY;

          if (deltaY > 0 && event === 'swipeY') {
            fn('swipeup');
          } else if (deltaY < 0 && event === 'swipeY') {
            fn('swipedown');
          } else if (deltaX > 0 && event === 'swipeX') {
            fn('swipeleft');
          } else if (deltaX < 0 && event === 'swipeX') {
            fn('swiperight');
          }
        }
      };
    }

    /**
     * @param {String} event
     * @param {Function} fn
     */

  }, {
    key: 'on',
    value: function on(event, fn) {
      var countHandlers = this._handlers.push(fn);
      var index = countHandlers - 1;
      var handler = this._wrapper(event, fn);

      this._wrappedHandlers[index] = handler;

      this._el.addEventListener('touchstart', handler);
      this._el.addEventListener('touchend', handler);
    }

    /**
     * @param {String} event
     * @param {Function} fn
     */

  }, {
    key: 'off',
    value: function off(event, fn) {
      var index = this._handlers.indexOf(fn);

      if (index === -1) {
        return;
      }

      var handler = this._wrappedHandlers[index];

      this._el.removeEventListener('touchend', handler);
      this._el.removeEventListener('touchstart', handler);

      delete this._handlers[index];
      delete this._wrappedHandlers[index];
    }
  }]);

  return TouchHandler;
}();

/* harmony default export */ __webpack_exports__["a"] = (TouchHandler);

/***/ }),

/***/ "dPBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNotification_vue__ = __webpack_require__("K1ME");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48d78044_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNotification_vue__ = __webpack_require__("8dJZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48d78044_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e2ZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheNavTitles__ = __webpack_require__("tqpC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CertificazioniPage',

  components: {
    TheNavTitles: __WEBPACK_IMPORTED_MODULE_0__components_TheNavTitles__["a" /* default */]
  },

  data: function data() {
    return {
      loaded: false,
      sections: [],
      title: 'Certificazioni'
    };
  },
  created: function created() {
    this.fetchData();
  },


  methods: {
    fetchData: function fetchData() {
      this.$http.get('/static/api/certificazioni.json').then(this.onFulfilled);
    },
    onFulfilled: function onFulfilled(res) {
      var data = res.data;

      this.sections = data.content.sections;
      this.loaded = true;
    }
  }
});

/***/ }),

/***/ "eZUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"link link_back-to-news",attrs:{"to":"/news"}},[_vm._v("Back to news")]),_vm._v(" "),_c('h1',{staticClass:"title title_h1_news-item-page"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"news-item news-item_full"},[_c('div',{staticClass:"news-item__wrapper"},[_c('div',{staticClass:"news-item__date"},[_vm._v(_vm._s(_vm.date))]),_vm._v(" "),_c('div',{staticClass:"news-item__content"},[_vm._v(_vm._s(_vm.shortDesc))])])])],1),_vm._v(" "),_c('div',{staticClass:"news-item news-item_full"},[_c('div',{staticClass:"news-item__image",style:({ 'background-image' : ("url(" + _vm.image + ")") })})]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"news-item news-item_full"},[_c('div',{staticClass:"news-item__desc",domProps:{"innerHTML":_vm._s(_vm.desc)}})]),_vm._v(" "),_c('div',{staticClass:"pagination pagination_news-item-page"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.prev !== null),expression:"this.prev !== null"}],staticClass:"pagination__prev"},[_c('a',{staticClass:"link link_gray",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClickPrevNewsLink.apply(null, arguments)}}},[_vm._v("Prev news")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.next !== null),expression:"this.next !== null"}],staticClass:"pagination__next"},[_c('a',{staticClass:"link link_gray",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClickNextNewsLink.apply(null, arguments)}}},[_vm._v("Next news")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fHMA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormControlCheckbox__ = __webpack_require__("NO6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormControlFile__ = __webpack_require__("5Dq/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormControlText__ = __webpack_require__("KTZ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormControlSelect__ = __webpack_require__("Zibr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormControl',

  components: {
    FormControlCheckbox: __WEBPACK_IMPORTED_MODULE_0__components_FormControlCheckbox__["a" /* default */],
    FormControlFile: __WEBPACK_IMPORTED_MODULE_1__components_FormControlFile__["a" /* default */],
    FormControlText: __WEBPACK_IMPORTED_MODULE_2__components_FormControlText__["a" /* default */],
    FormControlSelect: __WEBPACK_IMPORTED_MODULE_3__components_FormControlSelect__["a" /* default */]
  },

  props: {
    label: {
      type: String,
      default: null
    },

    name: {
      type: String,
      required: true
    },

    type: {
      type: String,
      default: 'text'
    },

    options: {
      type: Array
    },

    required: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      focused: false,
      filled: false,
      mustFilled: false,
      value: null
    };
  },


  methods: {
    onFilled: function onFilled(value) {
      this.filled = value;

      if (value && this.mustFilled) {
        this.mustFilled = false;
        this.$parent.$emit('fixed');
      }
    },
    onFocused: function onFocused(value) {
      this.focused = value;
    },
    onValue: function onValue(value) {
      this.value = value;
    }
  }
});

/***/ }),

/***/ "hEtS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-control",class:{
    'form-control_required' : _vm.mustFilled,
    'form-control_text'     : _vm.type === 'text',
    'form-control_tel'      : _vm.type === 'tel',
    'form-control_email'    : _vm.type === 'email',
    'form-control_file'     : _vm.type === 'file',
    'form-control_checkbox' : _vm.type === 'checkbox',
    'form-control_select'   : _vm.type === 'select',
    'form-control_focused'  : _vm.focused,
    'form-control_filled'   : _vm.filled,
  }},[(_vm.label !== null)?_c('label',{staticClass:"form-control__label",attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_vm._t("before",null,{"value":_vm.value}),_vm._v(" "),(_vm.type === 'file')?_c('form-control-file',{staticClass:"form-control__el",attrs:{"name":_vm.name,"multiple":true},on:{"filled":_vm.onFilled,"value":_vm.onValue}}):(_vm.type === 'checkbox')?_c('form-control-checkbox',{staticClass:"form-control__el",attrs:{"name":_vm.name},on:{"filled":_vm.onFilled}}):(_vm.type === 'select')?_c('form-control-select',{staticClass:"form-control__el",attrs:{"name":_vm.name,"options":_vm.options},on:{"filled":_vm.onFilled,"focused":_vm.onFocused,"value":_vm.onValue}}):_c('form-control-text',{staticClass:"form-control__el",attrs:{"name":_vm.name,"type":_vm.type},on:{"filled":_vm.onFilled,"focused":_vm.onFocused,"value":_vm.onValue}}),_vm._v(" "),_vm._t("after")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iUn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheNavTitles__ = __webpack_require__("tqpC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AboutUsPage',

  components: {
    TheNavTitles: __WEBPACK_IMPORTED_MODULE_0__components_TheNavTitles__["a" /* default */]
  },

  data: function data() {
    return {
      title: 'Professionals',
      logotypes: [],
      images: [{
        title: null,
        src: null
      }, {
        title: null,
        src: null
      }],
      certificate: [],
      section01: {
        title: null,
        desc: null
      },
      section02: {
        title: null,
        desc: null
      },
      section03: {
        title: null,
        desc: null
      },
      section04: {
        title: null,
        desc: null
      },
      section05: {
        title: null,
        desc: null
      },
      facts: {
        offices: 2,
        warehouses: 4,
        storage: 44,
        vans: 50,
        trucks: 14
      },
      loaded: false
    };
  },
  created: function created() {
    this.fetchData();
  },


  methods: {
    fetchData: function fetchData() {
      this.$http.get('/static/api/about.json').then(this.onFulfilled);
    },
    onFulfilled: function onFulfilled(res) {
      var data = res.data;

      this.section01 = data.section01;
      this.section02 = data.section02;
      this.section03 = data.section03;
      this.section04 = data.section04;
      this.section05 = data.section05;

      console.log('this.section05', this.section05);

      this.logotypes = data.logotypes;
      this.images = data.images;

      this.certificate = data.certificate;

      this.loaded = true;
    }
  }
});

/***/ }),

/***/ "igX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryImages_vue__ = __webpack_require__("NA+z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186204bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryImages_vue__ = __webpack_require__("dHT0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryImages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186204bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryImages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jSVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('div',{staticClass:"not-found not-found_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"not-found__caption"},[_vm._v("Oops, there’s a problem. The page you are looking for is not here (anymore). "),_c('router-link',{staticClass:"link link_black",attrs:{"to":"/"}},[_vm._v("Go to main page")]),_vm._v(".")],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found__image"},[_c('img',{attrs:{"src":"/static/404.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jcmg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_TouchHandler__ = __webpack_require__("dKUt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Utils__ = __webpack_require__("ppOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MainPage',

  components: {},

  filters: {
    leadingZero: function leadingZero(value) {
      return value > 9 ? value : '0' + value;
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Utils__["a" /* default */]],

  props: {
    slideURL: {
      type: String,
      default: null
    }
  },

  data: function data() {
    return {
      detailedView: false,
      loaded: false,
      slides: [],
      slideURLs: [],
      touchArea: null,
      videoPreview: true,
      videoControls: false,
      videoPlay: false,
      videoPath: false
    };
  },


  computed: {
    slidesCount: function slidesCount() {
      return this.slides.length;
    },
    slideIndex: function slideIndex() {
      var index = this.slideURLs.indexOf(this.slideURL);

      if (index === -1) {
        this.$router.replace({ name: 'NotFound' });
      }

      return index;
    },
    indexNextSlide: function indexNextSlide() {
      var slidesCount = this.slidesCount;
      var nextIndex = this.slideIndex + 1;
      var condition = nextIndex > slidesCount - 1;

      return condition ? null : nextIndex;
    },
    indexPrevSlide: function indexPrevSlide() {
      var prevIndex = this.slideIndex - 1;
      var condition = prevIndex < 0;

      return condition ? null : prevIndex;
    },
    currentSlide: function currentSlide() {
      return this.slides[this.slideIndex];
    },
    nextSlide: function nextSlide() {
      var indexNextSlide = this.indexNextSlide;

      return indexNextSlide === null ? null : this.slides[indexNextSlide];
    }
  },

  watch: {
    $route: function $route() {
      if (this.detailedView) {
        this.toggleDetailedView();

        this.toggleSide({
          isLeftSide: false,
          show: false
        });
      }
    }
  },

  created: function created() {
    var _this = this;

    document.body.classList.add('body_main-page');
    // @TODO
    // Выяснить почему последний узел сбрасывает устанавливаемый класс без
    // обёртки $nextTick
    this.$nextTick(function () {
      _this.toggleClasses(true);
    });

    this.setUrlByIndex = this.setUrlByIndex();
    this.onWheelWindow = debounce(this.onWheelWindow, 100);

    this.fetchData();

    window.addEventListener('resize', this.onResizeWindow);
  },
  mounted: function mounted() {
    this.touchArea = new __WEBPACK_IMPORTED_MODULE_0__js_TouchHandler__["a" /* default */](this.$el);
  },
  beforeUpdate: function beforeUpdate() {
    this.setVideoPath();
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('body_main-page');

    this.toggleClasses(false);
    this.$emit('switchLogo', { variant: 0 });

    window.removeEventListener('resize', this.onResizeWindow);

    window.removeEventListener('wheel', this.onWheelWindow);
    window.removeEventListener('keyup', this.onKeyup);
  },


  methods: {
    fetchData: function fetchData() {
      this.$http.get('/static/api/main.json').then(this.onFulfilled);
    },
    setVideoPath: function setVideoPath() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/videos/' + this.slideURL).then(function (response) {
        _this2.videoPath = response.data.video_path;
      }).catch(function (error) {
        _this2.videoPath = false;
      });
    },
    calculateHeightWindow: function calculateHeightWindow() {
      var htmlNode = document.documentElement;
      var slideNode = this.$refs.slide;
      var slideCompStyle = getComputedStyle(slideNode);
      var slideMarginTop = +slideCompStyle.marginTop.match(/(\d+)/gi)[0];
      var slideHeight = slideNode.clientHeight + slideMarginTop;

      var windowHeight = window.innerHeight;

      if (windowHeight > slideHeight) {
        htmlNode.style.height = windowHeight + 'px';
      } else {
        htmlNode.style.height = slideHeight + 'px';
      }
    },
    setUrlByIndex: function setUrlByIndex() {
      var _this3 = this;

      var isWaiting = false;

      return function (index) {
        if (index !== null && _this3.slideIndex !== index && !isWaiting) {
          isWaiting = true;

          var path = _this3.slideURLs[index] !== null ? _this3.slideURLs[index] : '';

          _this3.$router.push({ path: '/' + path });

          setTimeout(function () {
            isWaiting = false;
          }, 850);
        }
      };
    },
    toggleDetailedView: function toggleDetailedView() {
      var _this4 = this;

      var sectionNode = this.$refs.section;
      var slideNode = this.$refs.slide;

      if (this.detailedView) {
        this.$emit('switchLogo', { variant: 0 });
        this.$emit('switchNavSwitch', { variant: 0 });
        this.showFigure();
        this.touchArea.on('swipeY', this.onSwipeY);

        sectionNode.classList.remove('section_detailed-view');
        slideNode.classList.remove('slide_detailed-view');

        window.addEventListener('keyup', this.onKeyup);
        window.addEventListener('wheel', this.onWheelWindow);

        this.detailedView = false;
        this.videoControls = false;
        this.videoPreview = true;
        var video = document.querySelector('.service__video');
        video.pause();

        document.documentElement.style.height = null;
      } else {
        this.$emit('switchLogo', { variant: 1 });
        this.$emit('switchNavSwitch', { variant: 1 });
        this.hideFigure();
        this.touchArea.off('swipeY', this.onSwipeY);

        sectionNode.classList.add('section_detailed-view');
        slideNode.classList.add('slide_detailed-view');

        window.removeEventListener('wheel', this.onWheelWindow);
        window.removeEventListener('keyup', this.onKeyup);

        this.detailedView = true;

        this.$nextTick(function () {
          _this4.calculateHeightWindow();
        });

        this.setVideoPath();
      }
    },
    toggleSide: function toggleSide() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.isMobile || this.detailedView) {
        return;
      };

      var _options$isLeftSide = options.isLeftSide,
          isLeftSide = _options$isLeftSide === undefined ? true : _options$isLeftSide,
          _options$show = options.show,
          show = _options$show === undefined ? true : _options$show;


      var figurePath = this.$refs.figurePath;
      var sectionNode = this.$refs.section;
      var specialNode = this.$refs.special;
      var captionNodeSlideMove = this.$refs.captionSlideMove;

      if (show && isLeftSide) {
        sectionNode.classList.add('section_collapse-right');
        specialNode.classList.add('special_test');
        captionNodeSlideMove.classList.add('caption_hide');
        this.$emit('hideFooter');
      } else if (!show && isLeftSide) {
        sectionNode.classList.remove('section_collapse-right');
        specialNode.classList.remove('special_test');
        captionNodeSlideMove.classList.remove('caption_hide');
        this.$emit('showFooter');
      } else if (show && !isLeftSide) {
        sectionNode.classList.add('section_collapse-left');
        specialNode.classList.add('special_hide');
        this.$emit('switchLogo', { variant: 2 });
      } else {
        sectionNode.classList.remove('section_collapse-left');
        specialNode.classList.remove('special_hide');
        this.$emit('switchLogo', { variant: 0 });
      }

      this.animate({
        duration: 400,

        draw: function draw(progress) {
          var topWidth = null;
          var bottomWidth = null;
          var path = null;

          if (show && isLeftSide) {
            topWidth = 37.5 + 62.5 * progress;
            bottomWidth = 18.75 + 81.25 * progress;
          } else if (!show && isLeftSide) {
            topWidth = 100 - 62.5 * progress;
            bottomWidth = 100 - 81.25 * progress;
          } else if (show && !isLeftSide) {
            topWidth = 37.5 - 31.25 * progress;
            bottomWidth = 18.75 - 12.5 * progress;
          } else {
            topWidth = 6.25 + 31.25 * progress;
            bottomWidth = 6.25 + 12.5 * progress;
          }

          path = 'M0 0 H' + topWidth + ' L' + bottomWidth + ' 100 H0 Z';
          figurePath.setAttribute('d', path);
        }
      });

      setTimeout(function () {
        var el = document.getElementsByClassName('special__caption');
        if (show && !isLeftSide) {
          el[0].style.display = 'none';
        } else {
          el[0].style.display = 'block';
        }
      }, 410);
    },
    onFulfilled: function onFulfilled(res) {
      var data = res.data.filter(function (item) {
        return item.hide !== true;
      });

      this.slides = data;
      this.slideURLs = this.slides.map(function (item) {
        return item.url;
      });
      this.loaded = true;

      this.touchArea.on('swipeY', this.onSwipeY);
      window.addEventListener('keyup', this.onKeyup);
      window.addEventListener('wheel', this.onWheelWindow);
    },
    onSwipeY: function onSwipeY(direction) {
      if (direction === 'swipeup') {
        this.setUrlByIndex(this.indexPrevSlide);
      } else {
        this.setUrlByIndex(this.indexNextSlide);
      }
    },
    onKeyup: function onKeyup(e) {
      switch (e.keyCode) {
        case 38:
          this.setUrlByIndex(this.indexPrevSlide);
          break;
        case 40:
          this.setUrlByIndex(this.indexNextSlide);
        default:
          break;
      }
    },
    onClickLearnMore: function onClickLearnMore() {
      var options = {
        isLeftSide: false
      };

      this.toggleSide(options);
      this.toggleDetailedView();
    },
    onClickSlideTitle: function onClickSlideTitle() {
      if (this.isMobile || this.currentSlide.id === 0) {
        return;
      }

      this.toggleDetailedView();
    },
    onClickBack: function onClickBack() {
      var options = {
        isLeftSide: false,
        show: false
      };

      this.toggleDetailedView();
      this.toggleSide(options);
    },
    onMouseEnterSpecialTitle: function onMouseEnterSpecialTitle() {
      this.toggleSide();
    },
    onMouseLeaveSpecialTitle: function onMouseLeaveSpecialTitle() {
      var options = {
        show: false
      };

      this.toggleSide(options);
    },
    onMouseEnterSlideTitle: function onMouseEnterSlideTitle() {
      var options = {
        isLeftSide: false
      };

      this.toggleSide(options);
    },
    onMouseLeaveSlideTitle: function onMouseLeaveSlideTitle() {
      var options = {
        isLeftSide: false,
        show: false
      };

      this.toggleSide(options);
    },
    onResizeWindow: function onResizeWindow() {
      if (this.detailedView) {
        this.calculateHeightWindow();
      }
    },
    onClickCaptionTitleNextSlide: function onClickCaptionTitleNextSlide() {
      this.setUrlByIndex(this.indexNextSlide);
    },
    onClickVideo: function onClickVideo() {
      this.videoPreview = false;
      this.videoControls = 'controls';
      this.videoPlay = true;
      var video = document.querySelector('.service__video');
      video.play();
    },
    onWheelWindow: function onWheelWindow(e) {
      if (e.deltaY > 0) {
        this.setUrlByIndex(this.indexNextSlide);
      } else {
        this.setUrlByIndex(this.indexPrevSlide);
      }
    },
    hideFigure: function hideFigure() {
      var figurePath = this.$refs.figurePath;

      this.animate({
        duration: 400,

        draw: function draw(progress) {
          var topWidth = 6.25 - 6.25 * progress;
          var bottomWidth = 6.25 - 6.25 * progress;
          var path = 'M0 0 H' + topWidth + ' L' + bottomWidth + ' 100 H0 Z';

          figurePath.setAttribute('d', path);
        }
      });

      this.$emit('switchLogo', { variant: 1 });
    },
    showFigure: function showFigure() {
      var figurePath = this.$refs.figurePath;

      this.animate({
        duration: 400,

        draw: function draw(progress) {
          var topWidth = 6.25 * progress;
          var bottomWidth = 6.25 * progress;
          var path = 'M0 0 H' + topWidth + ' L' + bottomWidth + ' 100 H0 Z';

          figurePath.setAttribute('d', path);
        }
      });

      this.$emit('switchLogo', { variant: 2 });
    },
    onClickSpecialLink: function onClickSpecialLink() {
      this.moveToAboutUsPage();
    },
    onClickSpecialTitle: function onClickSpecialTitle() {
      this.moveToAboutUsPage();
    },
    moveToAboutUsPage: function moveToAboutUsPage() {
      var _this5 = this;

      this.$refs.special.classList.add('special_test_2');

      setTimeout(function () {
        _this5.$router.push({ name: 'AboutUs' });
      }, 400);
    }
  }
});

/**
 * @param {Function} f
 * @param {Number} ms
 * @return {Function}
 */
function debounce(f, ms) {
  var state = null;

  /** @this Vue */
  return function () {
    if (state) {
      return;
    };

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    f.apply(this, args);

    state = true;

    setTimeout(function () {
      state = null;
    }, ms);
  };
}

/***/ }),

/***/ "jjAL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Utils__ = __webpack_require__("ppOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormContainer__ = __webpack_require__("YVAl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormControl__ = __webpack_require__("QDBU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GalleryImages__ = __webpack_require__("igX2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TheNavTitles__ = __webpack_require__("tqpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_TouchHandler__ = __webpack_require__("dKUt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_recaptcha__ = __webpack_require__("olAn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CareerPage',

  components: {
    FormContainer: __WEBPACK_IMPORTED_MODULE_1__components_FormContainer__["a" /* default */],
    FormControl: __WEBPACK_IMPORTED_MODULE_2__components_FormControl__["a" /* default */],
    GalleryImages: __WEBPACK_IMPORTED_MODULE_3__components_GalleryImages__["a" /* default */],
    TheNavTitles: __WEBPACK_IMPORTED_MODULE_4__components_TheNavTitles__["a" /* default */],
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_6_vue_recaptcha__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Utils__["a" /* default */]],

  data: function data() {
    return {
      apply: {
        title: null,
        desc: null
      },
      images: [],
      lead: {
        title: null,
        desc: null
      },
      loaded: false,
      positions: {
        title: null,
        desc: null,
        items: []
      },
      optionsRegion: [{ text: 'Abruzzo', value: 'Abruzzo' }, { text: 'Basilicata', value: 'Basilicata' }, { text: 'Calabria', value: 'Calabria' }, { text: 'Campania', value: 'Campania' }, { text: 'Emilia-Romagna', value: 'Emilia-Romagna' }, { text: 'Friuli-Venezia Giulia', value: 'Friuli-Venezia Giulia' }, { text: 'Lazio', value: 'Lazio' }, { text: 'Liguria', value: 'Liguria' }, { text: 'Lombardia', value: 'Lombardia' }, { text: 'Marche', value: 'Marche' }, { text: 'Molise', value: 'Molise' }, { text: 'Piemonte', value: 'Piemonte' }, { text: 'Puglia', value: 'Puglia' }, { text: 'Sardegna', value: 'Sardegna' }, { text: 'Sicilia', value: 'Sicilia' }, { text: 'Toscana', value: 'Toscana' }, { text: 'Trentino-Alto Adige', value: 'Trentino-Alto Adige' }, { text: 'Umbria', value: 'Umbria' }, { text: 'Valle d\'Aosta', value: 'Valle d\'Aosta' }, { text: 'Veneto', value: 'Veneto' }],
      optionsVakancy: [{ text: 'Promoter/Hostess', value: 'Promoter/Hostess' }, { text: 'Allestitore/Merchandiser', value: 'Allestitore/Merchandiser' }, { text: 'Mystery client', value: 'Mystery client' }, {
        text: 'Commerciale/In Store Account/Sales Merchandiser',
        value: 'Commerciale/In Store Account/Sales Merchandiser'
      }, { text: 'Altro', value: 'Altro' }],
      title: 'Career',
      touchArea: null,
      rcapt_sig_key: '6LelKDkUAAAAAMYCC2SBR4x6QpJHZPXneljYEOD0',
      rcapt_id: 0
    };
  },
  created: function created() {
    this.fetchData();
    // this.loadScript();
  },


  methods: {
    fetchData: function fetchData(res) {
      this.$http.get('/static/api/career.json').then(this.onFulfilled);
    },
    onFulfilled: function onFulfilled(res) {
      var _this = this;

      var data = res.data;

      this.apply = data.apply;
      this.images = data.images;
      this.lead = data.lead;
      this.positions = data.positions;

      this.loaded = true;

      this.$nextTick(function () {
        _this.touchArea = new __WEBPACK_IMPORTED_MODULE_5__js_TouchHandler__["a" /* default */](_this.$refs.gallery.$el);
        _this.touchArea.on('swipeX', _this.onSwipeX);
      });
    },
    onSwipeX: function onSwipeX(direction) {
      if (direction === 'swipeleft') {
        this.$refs.gallery.prevImage();
      } else {
        this.$refs.gallery.nextImage();
      }
    }
  }
});

/***/ }),

/***/ "lUiH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('div',{staticClass:"nav__logo"},[_c('router-link',{staticClass:"logo logo_inside_nav",attrs:{"to":"/","exact":""}},[_c('div',{staticClass:"logo__image"}),_vm._v(" "),_c('div',{staticClass:"logo__caption"},[_vm._v("Trade"),_c('br'),_vm._v("marketing")])])],1),_vm._v(" "),_c('div',{staticClass:"nav__container"},[_c('div',{staticClass:"nav__items"},[_vm._l((_vm.items),function(item,indexItem){return [(item.subitems !== null)?_c('div',{staticClass:"nav-item nav-item_subitems"},[_c('div',{staticClass:"nav-item__name",on:{"click":_vm.onClickItemName}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),(item.subitems !== null)?_c('div',{staticClass:"nav-item__subitems"},_vm._l((item.subitems),function(subitem,indexSubitem){return _c('div',{staticClass:"nav-subitem"},[_c('router-link',{staticClass:"nav-subitem__name",attrs:{"to":subitem.link},nativeOn:{"click":function($event){return _vm.onClickSubitemName.apply(null, arguments)}}},[_vm._v(_vm._s(subitem.name))])],1)}),0):_vm._e()]):_c('div',{staticClass:"nav-item"},[(_vm.getItems(item))?[_c('router-link',{staticClass:"nav-item__name",attrs:{"to":item.link},nativeOn:{"click":function($event){return _vm.onClickItemName.apply(null, arguments)}}},[_vm._v(_vm._s(item.name))])]:_vm._e()],2)]})],2),_vm._v(" "),_c('div',{staticClass:"nav__contacts"},[_c('router-link',{staticClass:"link link_work-with-us",attrs:{"to":"/career"}},[_vm._v("Work with us")]),_vm._v(" "),_c('div',{staticClass:"social-networks social-networks_nav"},[_c('a',{staticClass:"social-networks__item social-networks__item_youtube social-network social-network_nav",attrs:{"href":"//www.youtube.com/4mktg","target":"_blank"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 17"}},[_c('path',{staticClass:"social-network__content",attrs:{"fill-rule":"nonzero","d":"M18.78 0H4.923C2.203 0 0 2.234 0 4.99v7.02C0 14.767 2.204 17 4.923 17H18.78c2.72 0 4.923-2.234 4.923-4.99V4.99C23.703 2.233 21.5 0 18.78 0zm-3.33 8.842l-6.48 3.133c-.173.083-.373-.044-.373-.238V5.275c0-.197.205-.325.378-.236l6.48 3.328c.194.1.19.38-.004.474z"}})])]),_vm._v(" "),_c('a',{staticClass:"social-networks__item social-networks__item_twitter social-network social-network_nav",attrs:{"href":"//twitter.com/4MKTG","target":"_blank"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23 19"}},[_c('path',{staticClass:"social-network__content",attrs:{"fill-rule":"nonzero","d":"M23 2.248c-.847.38-1.755.64-2.71.756.975-.594 1.72-1.535 2.075-2.653-.914.55-1.923.95-2.998 1.166C18.507.582 17.28 0 15.923 0c-2.606 0-4.718 2.15-4.718 4.797 0 .376.04.743.122 1.093-3.92-.2-7.398-2.11-9.725-5.013C1.196 1.584.964 2.41.964 3.29c0 1.664.834 3.132 2.1 3.992C2.288 7.256 1.56 7.04.925 6.68v.06c0 2.324 1.627 4.263 3.784 4.705-.395.108-.812.168-1.243.168-.305 0-.6-.03-.89-.09.602 1.908 2.344 3.295 4.408 3.333-1.614 1.286-3.65 2.05-5.86 2.05-.38 0-.756-.022-1.125-.065C2.088 18.206 4.568 19 7.232 19c8.68 0 13.424-7.31 13.424-13.652l-.016-.62c.927-.673 1.73-1.518 2.36-2.48z"}})])]),_vm._v(" "),_c('a',{staticClass:"social-networks__item social-networks__item_facebook social-network social-network_nav",attrs:{"href":"//facebook.com/4MKTG.For.Marketing/","target":"_blank"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 24"}},[_c('path',{staticClass:"social-network__content",attrs:{"fill-rule":"nonzero","d":"M2.378 4.648v3.304H0v4.04h2.378V24h4.884V11.993h3.277s.306-1.937.455-4.056H7.28V5.175c0-.413.533-.97 1.06-.97H11V0H7.382C2.257 0 2.378 4.044 2.378 4.648z"}})])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mQH1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("UThT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59563d34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("95n6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59563d34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o46f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalWindow_vue__ = __webpack_require__("5DS7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b309bba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalWindow_vue__ = __webpack_require__("/a7v");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b309bba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pPVn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsItem_vue__ = __webpack_require__("BtGf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_969da6e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabsItem_vue__ = __webpack_require__("c67H");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_969da6e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabsItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ppOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isMobile: window.innerWidth < 992
    };
  },
  created: function created() {
    this.onResizeWindowGlobal = this.onResizeWindowGlobal();

    window.addEventListener('resize', this.onResizeWindowGlobal);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResizeWindowGlobal);
  },


  methods: {
    toggleClasses: function toggleClasses(flag, cssClass) {
      cssClass = cssClass || 'full-height';

      var nodes = [document.documentElement, document.body, document.getElementById('app')];

      if (flag) {
        nodes.forEach(function (item) {
          item.classList.add(cssClass);
        });
      } else {
        nodes.forEach(function (item) {
          item.classList.remove(cssClass);
        });
      }
    },
    animate: function animate(options) {
      var start = performance.now();

      var duration = options.duration,
          _options$timing = options.timing,
          timing = _options$timing === undefined ? linear : _options$timing,
          draw = options.draw;


      requestAnimationFrame(animate);

      /**
       * @param {Number} timeFraction
       * @return {Number}
       */
      function linear(timeFraction) {
        return timeFraction;
      }

      /**
       * @param {Number} time
       */
      function animate(time) {
        var timeFraction = (time - start) / duration;

        if (timeFraction > 1) {
          timeFraction = 1;
        }

        var progress = timing(timeFraction);

        draw(progress);

        if (timeFraction < 1) {
          requestAnimationFrame(animate);
        }
      }
    },
    onResizeWindowGlobal: function onResizeWindowGlobal() {
      var _this = this;

      var prevWidth = window.innerWidth;

      return function () {
        var currWidth = window.innerWidth;

        if (currWidth >= 992 && prevWidth < 992) {
          _this.isMobile = false;
        } else if (currWidth < 992 && prevWidth >= 992) {
          _this.isMobile = true;
        }

        prevWidth = currWidth;
      };
    }
  }
});

/***/ }),

/***/ "pxey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__ = __webpack_require__("Ene4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6522b077_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__ = __webpack_require__("eZUl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6522b077_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sJx0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form form_career",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_vm._t("default",null,{"verified":_vm.verified}),_vm._v(" "),_c('transition',{attrs:{"name":"v04","duration":800}},[(_vm.successfullySent)?_c('div',{staticClass:"message message_form-sent"},[_c('img',{staticClass:"message__icon",attrs:{"alt":"messageIcon","src":"/static/success.svg"}}),_vm._v(" "),_c('p',{staticClass:"message__text"},[_vm._v("Grazie per le informazioni. Sei entrata/o nel nostro data base. Ti contatteremo appena avremo opportunità nella tua area di lavoro.")])]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "syIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheNavTitles__ = __webpack_require__("tqpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_Cookie__ = __webpack_require__("z0Wd");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var gtaEnabled = __WEBPACK_IMPORTED_MODULE_1__js_Cookie__["a" /* default */].get('gta_disabled') === '0' ? true : false;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PrivacyPolicyPage',

  components: {
    TheNavTitles: __WEBPACK_IMPORTED_MODULE_0__components_TheNavTitles__["a" /* default */]
  },

  data: function data() {
    return {
      loaded: false,
      sections: [],
      title: 'Privacy policy',
      gtaEnabled: __WEBPACK_IMPORTED_MODULE_1__js_Cookie__["a" /* default */].get('gta_disabled') === '0' ? true : false
    };
  },
  created: function created() {
    this.fetchData();
    gtaEnabled = __WEBPACK_IMPORTED_MODULE_1__js_Cookie__["a" /* default */].get('gta_disabled') === '0' ? true : false;
  },


  methods: {
    fetchData: function fetchData() {
      this.$http.get('/static/api/privacyPolicy.json').then(this.onFulfilled);
    },
    onFulfilled: function onFulfilled(res) {
      var data = res.data;

      this.sections = data.content.sections;

      this.loaded = true;
    },
    toggleGta: function toggleGta() {
      console.log('1', gtaEnabled);
      gtaEnabled = !gtaEnabled;
      __WEBPACK_IMPORTED_MODULE_1__js_Cookie__["a" /* default */].set('gta_disabled', gtaEnabled ? '0' : '1', {
        expires: 31536000
      });
      window['ga-disable-UA-91170168-12'] = !gtaEnabled;
      console.log('2', gtaEnabled);
    }
  }
});

/***/ }),

/***/ "tWjo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormControlFile',

  props: {
    name: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      filled: false
    };
  },


  watch: {
    filled: function filled(value) {
      this.$emit('filled', value);
    }
  },

  methods: {
    onChange: function onChange() {
      console.log(this.$refs);
      var input = this.$refs.input;

      this.filled = input.files.length > 0;

      if (this.filled) {
        this.$emit('value', input.files);
      }
    }
  }
});

/***/ }),

/***/ "tqpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNavTitles_vue__ = __webpack_require__("ZioS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb5c3dfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNavTitles_vue__ = __webpack_require__("bNO+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNavTitles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb5c3dfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNavTitles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vZWG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"file","id":_vm.name,"name":_vm.name},on:{"change":_vm.onChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Utils__ = __webpack_require__("ppOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TheFooter__ = __webpack_require__("GyQG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TheNavigation__ = __webpack_require__("NgGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TheNotification__ = __webpack_require__("dPBF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',

  components: {
    TheFooter: __WEBPACK_IMPORTED_MODULE_1__components_TheFooter__["a" /* default */],
    TheNavigation: __WEBPACK_IMPORTED_MODULE_2__components_TheNavigation__["a" /* default */],
    TheNotification: __WEBPACK_IMPORTED_MODULE_3__components_TheNotification__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Utils__["a" /* default */]],

  data: function data() {
    return {
      navIsOpen: false,
      variantLogo: null,
      variantNavSwitch: null
    };
  },


  computed: {
    logoClasses: function logoClasses() {
      var cssClass = null;

      switch (this.variantLogo) {
        case 1:
          cssClass = 'logo_white';
          break;

        case 2:
          cssClass = 'logo_short';
          break;
      }

      return cssClass;
    },
    navSwitchClasses: function navSwitchClasses() {
      var cssClass = null;

      if (this.isMainPage && !this.isMobile && !this.navIsOpen) {
        if (this.variantNavSwitch === 1) {
          cssClass = 'button_nav-switch-white';
        }
      } else if (this.isMainPage && this.isMobile && !this.navIsOpen) {
        cssClass = 'button_nav-switch-white';
      } else if (this.navIsOpen) {
        cssClass = 'button_nav-close-button';
      }

      return cssClass;
    },
    isMainPage: function isMainPage() {
      return this.$route.name === 'Main';
    }
  },

  watch: {
    $route: function $route() {
      // Track a virtual page
      gaTrack(this.$route.path, '4MKTG — For Marketing');
      ga('send', 'pageview');

      if (this.navIsOpen) {
        this.hideNav();
      }
    }
  },

  methods: {
    onClickNavSwitch: function onClickNavSwitch() {
      this.navIsOpen = !this.navIsOpen;
    },
    hideNav: function hideNav() {
      this.navIsOpen = false;
    },
    onSwitchLogo: function onSwitchLogo(options) {
      var variantLogo = options.variant;


      this.variantLogo = variantLogo;
    },
    onSwitchNavSwitch: function onSwitchNavSwitch(options) {
      var _options$variant = options.variant,
          variantNavSwitch = _options$variant === undefined ? 0 : _options$variant;


      this.variantNavSwitch = variantNavSwitch;
    },
    onHideNav: function onHideNav() {
      this.hideNav();
    },
    onHideFooter: function onHideFooter() {
      var footerNode = this.$refs.footer.$el;

      footerNode.classList.add('footer_hide');
    },
    onShowFooter: function onShowFooter() {
      var footerNode = this.$refs.footer.$el;

      footerNode.classList.remove('footer_hide');
    }
  }
});

/***/ }),

/***/ "xhN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormContainer',

  data: function data() {
    return {
      successfullySent: null,
      verified: null,
      sending: false
    };
  },
  created: function created() {
    this.$on('fixed', this.onFixed);
  },


  methods: {
    onSubmit: function onSubmit() {
      this.checkFields();

      var formData = new FormData();

      formData.append('first_name', this.$children[0].value);
      formData.append('last_name', this.$children[1].value);
      formData.append('phone', this.$children[2].value);
      formData.append('email', this.$children[3].value);
      formData.append('region', this.$children[4].value);
      formData.append('city', this.$children[5].value);
      formData.append('vakancy', this.$children[6].value);

      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(this.$children[7].value, function (obj, v) {
        formData.append('file[]', v);
      });

      if (this.verified && !this.sending) {
        this.sending = true;
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.button_form-career-page').prop('disabled', true);
        this.$http.post('/career/request/add', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(this.onFulfilled).catch(function (res) {});
      }
    },
    checkFields: function checkFields() {
      var _this = this;

      var verified = true;

      this.$children.forEach(function (item) {
        if (!item.filled && item.required) {
          verified = false;
          _this.$set(item, 'mustFilled', true);
        }

        if (item.name === 'phone' && item.value) {
          if (item.value.replace(/[0-9+\-)( ]/g, '').trim() !== '') {
            verified = false;
            _this.$set(item, 'mustFilled', true);
          }
        }

        if (item.name === 'email') {
          if (_this.isEmail(item.value)) {
            verified = false;
            _this.$set(item, 'mustFilled', true);
          }
        }
      });

      this.verified = verified;
    },
    isEmail: function isEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return !re.test(email);
    },
    onFixed: function onFixed() {
      this.checkFields();
    },
    onFulfilled: function onFulfilled(res) {
      var _this2 = this;

      this.sending = false;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.button_form-career-page').prop('disabled', false);
      this.successfullySent = true;
      setTimeout(function () {
        _this2.onClickLinkWriteMore();
      }, 3000);
    },
    onClickLinkWriteMore: function onClickLinkWriteMore() {
      this.successfullySent = null;
    }
  }
});

/***/ }),

/***/ "yQyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormControlSelect',

  props: {
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      value: null

    };
  },


  computed: {
    filled: function filled() {
      return this.value === null ? false : this.value;
    }
  },

  watch: {
    value: function value(_value) {
      this.$emit('value', _value);
    },
    filled: function filled(value) {
      this.$emit('filled', value);
    },
    focused: function focused(value) {
      this.$emit('focused', value);
    }
  },

  methods: {
    onFocusFormControlEl: function onFocusFormControlEl() {
      this.focused = true;
    },
    onBlurFormControlEl: function onBlurFormControlEl() {
      this.focused = false;
    }
  }
});

/***/ }),

/***/ "yb/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewsPage',

  data: function data() {
    return {
      loaded: false,
      news: [],
      next: null
    };
  },
  created: function created() {
    this.fetchData();
  },


  methods: {
    fetchData: function fetchData(url) {
      url = url || '/api/news';

      this.$http.get(url).then(this.onFulfilled);
    },
    onFulfilled: function onFulfilled(res) {
      var _news;

      var data = res.data;

      (_news = this.news).push.apply(_news, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.news));
      this.next = data.next;

      this.loaded = true;
    },
    onClickViewMoreLink: function onClickViewMoreLink() {
      this.fetchData(this.next);
    }
  }
});

/***/ }),

/***/ "z0Wd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Cookies manipulation
 */
var Cookie = function () {
  function Cookie() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Cookie);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Cookie, null, [{
    key: 'get',

    /**
     * Возвращает cookie с именем name, если есть, если нет, то undefined
     * @param {String} name
     * @return {String|undefined}
     */
    value: function get(name) {
      var regexp = new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)');

      var matches = document.cookie.match(regexp);

      return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    /**
     * Устанавливает cookie с именем name и значением value
     * options - объект с свойствами cookie (expires, path, domain, secure)
     * @param {String} name
     * @param {String} value
     * @param {Object} options
     */

  }, {
    key: 'set',
    value: function set(name, value, options) {
      options = options || {};

      var expires = options.expires;

      if (typeof expires == 'number' && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
      }

      if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
      }

      value = encodeURIComponent(value);

      var updatedCookie = name + '=' + value;

      for (var propName in options) {
        if (options.hasOwnProperty(propName)) {
          updatedCookie += '; ' + propName;

          var propValue = options[propName];

          if (propValue !== true) {
            updatedCookie += '=' + propValue;
          }
        }
      }

      document.cookie = updatedCookie;
    }

    /**
     * @param {String} name
     */

  }, {
    key: 'delete',
    value: function _delete(name) {
      setCookie(name, '', {
        expires: -1
      });
    }
  }]);

  return Cookie;
}();

;

/* harmony default export */ __webpack_exports__["a"] = (Cookie);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f330ce60dc0348d9b1ec.js